import React from 'react';

import { TierSliderRow } from '../shared/TierSliderRow';

import type { TieredRates } from '../../../../../utils/rateExtractor';

interface ThreeTierSectionProps {
	rates: TieredRates;
	onRateChange: (tier: keyof TieredRates, value: number) => void;
	title?: string;
}

export const ThreeTierSection: React.FC<ThreeTierSectionProps> = ({
	rates,
	onRateChange,
	title = '3-tier Pricing Model',
}) => {
	return (
		<div className="space-y-6">
			<h4 className="text-lg font-semibold text-gray-900 my-4">{title}</h4>

			<div className="space-y-6">
				{/* Qualified Row */}
				<TierSliderRow
					tierName="Qualified"
					rateValue={rates.qualified_rate}
					feeValue={rates.qualified_per_item}
					onRateChange={(value) => onRateChange('qualified_rate', value)}
					onFeeChange={(value) => onRateChange('qualified_per_item', value)}
				/>

				{/* Mid-Qualified Row */}
				<TierSliderRow
					tierName="Mid-Qualified"
					rateValue={rates.midqualified_rate}
					feeValue={rates.midqualified_per_item}
					onRateChange={(value) => onRateChange('midqualified_rate', value)}
					onFeeChange={(value) => onRateChange('midqualified_per_item', value)}
				/>

				{/* Non-Qualified Row */}
				<TierSliderRow
					tierName="Non-Qualified"
					rateValue={rates.nonqualified_rate}
					feeValue={rates.nonqualified_per_item}
					onRateChange={(value) => onRateChange('nonqualified_rate', value)}
					onFeeChange={(value) => onRateChange('nonqualified_per_item', value)}
				/>
			</div>
		</div>
	);
};
